import React, { useEffect, useState } from 'react';
import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import AxiosClient from '../../assets/AxiosClient.js';
import SliderRow from './SliderRow.jsx';
import Loader from '../../assets/tools/Loder/loader';
import { DataTable, PageHeader } from '../../componants/Workspace';

const Slides = () => {
  const { SetNotification } = useStateContext();
  const [Slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [SlidesPerPage] = useState(7);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get('/slides');
        const res  = await response.data;
        setSlides(res);
      } catch (error) {
        SetNotification('Error fetching data:', 'danger');
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  const indexOfLastPaper = currentPage * SlidesPerPage;
  const indexOfFirstPaper = indexOfLastPaper - SlidesPerPage;
  const currentSlides = Slides.slice(indexOfFirstPaper, indexOfLastPaper);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <PageHeader
        title="Slides"
        description="Manage the published slide collection."
      />
      {loading ? (
        <div className="workspace-loading"><Loader label="Loading slides..." /></div>
      ) : Slides.length === 0 ? (
        <div className="workspace-empty">No slides are available.</div>
      ) : (
        <DataTable>
            <thead>
              <tr className='ro2'>
                <th className='col-2'>Title </th>
               
              </tr>
            </thead>
            <tbody>
              {currentSlides.map((Slide) => <SliderRow key={Slide.id} slider={Slide} />)}
            </tbody>
        </DataTable>
      )}
      {!loading && Slides.length > SlidesPerPage && (
        <nav className="workspace-pagination" aria-label="Slide pages">
          <ul className="pagination mb-0">
            {Array.from({ length: Math.ceil(Slides.length / SlidesPerPage) }, (_, index) => (
              <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                <button className="page-link" onClick={() => paginate(index + 1)} aria-current={currentPage === index + 1 ? 'page' : undefined}>
                  {index + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </>
  );
};

export default Slides;